import * as React from "react"
import {useEffect} from "react"
import {Navigate} from "react-router-dom";

import {SESSION_ROUTES} from "@constants";
import {useUserApp} from "@hooks";


export default function LogoutPage() {
	const { handleLogout } = useUserApp()

	useEffect(() => {
		handleLogout()
	}, [])

	return <Navigate to={SESSION_ROUTES.LOGIN_URL} replace />
}